const vars = {
  primaryFont: '"Manrope", Roboto, "Helvetica Neue", Arial, sans-serif'
};

export default vars;